// Default theme values from blankTheme in upsert-institution.js
export const DEFAULT_THEME_VALUES = {
    logoVertical: '/assets/icons/legacy/logo-vertical-black.png',
    logoHorizontal: '/assets/icons/legacy/logo-horizontal-black.png',
    frontColor: '#8a7b7b',
    backgroundColor: '#ffffff',
    authBoxBackground: '#ffffff',
    authBoxOpacity: '1',
    contrastFront: '#ffffff',
    sidebarTextColor: '#a8a8a8',
    behindLogoColor: '#ffffff',
    behindLogoOpacity: '1',
    verticalLogoScale: '1',
    horizontalLogoScale: '1',
    favicon: '',
    backgroundImage: '',
    contrastBack: '',
    welcomeScreenText: '',
    sidebarIconsColor: '',
};
